<template>
    <h3 v-if="title"> {{ title }} </h3>
    <div class="border-dark-lighter mt-2 border-b-2 pb-3 text-sm">
        <Paragraph>
            <slot />
        </Paragraph>
        <div v-if="$slots.link" class="text-brand-base mt-1">
            <slot name="link" />
        </div>
    </div>
</template>

<script setup>
import Paragraph from '@/components/Paragraph.vue'

const props = defineProps({
    title: { type: String, default: undefined },
})
</script>
